import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton } from "@mui/material";

export default function Search({ searchKey, setPage, setSearchKey }) {
  return (
    <Paper
      component="form"
      elevation={0}
      sx={{
        p: "15px 18px",
        display: "flex",
        alignItems: "center",
        width: "inherit",
        height: "50px",
        borderRadius: "30px",
        justifyContent: "space-between",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      }}
    >
      <InputBase
        sx={{
          ml: 1,
          flex: 1,
          color: "rgba(128, 128, 128, 0.7)",
        }}
        placeholder="Search "
        onChange={(e) => {
          setPage(1);

          setSearchKey(e.target.value);
        }}
      />

      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon style={{ color: "#231F20" }} />
      </IconButton>
    </Paper>
  );
}
